export default class DuplicateTouchdown extends Error {
    constructor() {
        super("Play cannot result in Touchdown!");
    }
}
